	<template>
	<div class="innerBox">
		<div class="row">
			<div class="col-6">
				<h1>Gatepass Mobil</h1>
			</div>
			<div class="col-6 text-right">
				<button type="button" class="btn btn-primary ml-5 mb-3" @click="$router.push('/finance/work-order-payment')" style="width: 100px;">< Kembali</button>
			</div>
		</div>
		

		<!-- <div class="row row-space">
		<div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
			<div class="input-group">
			<label class="label">ID Work Order<span style="color: red;">*</span></label>
			<MultiSelect
				v-model="workorder_id"
				:options="options.workorder.map(type => type.form_id)"
				:custom-label="opt => options.workorder.find(x => x.form_id == opt).form_code"
				:searchable="true"
				:close-on-select="true"
				:multiple="false"
				:allow-empty="false"
				placeholder="Pilih ID Work Order"
				disabled
			></MultiSelect>
			</div>
		</div>
		</div> -->

		<div class="outerBox" style="margin: 20px 0">
			<div class="innerBox">
				<h4 style="margin: 0" :style="(workorder_detail == null) ? 'color:grey' : ''">Work Order Detail</h4>
				<hr v-if="workorder_detail != null">
				<div class="row" v-if="workorder_detail != null">
					<div class="col-md-4">
						<p class="text-label">Merk Mobil</p>
						<p class="text-content">{{ workorder_detail.car_brand_name }}</p>
					</div>
					<div class="col-md-4">
						<p class="text-label">Tipe Mobil</p>
						<p class="text-content">{{ workorder_detail.car_type_name }}</p>
					</div>
					<div class="col-md-4">
						<p class="text-label">Nomor Polisi</p>
						<p class="text-content">{{ workorder_detail.registration }}</p>
					</div>
				</div>
				<div class="row" :class="{'mt-5' : !mobile}" v-if="workorder_detail != null">
					<div class="col-md-4">
						<p class="text-label">Tanggal Tawar</p>
						<p class="text-content">{{ workorder_detail.start_date.slice(0,11) }}</p>
					</div>
					<div class="col-md-4">
						<p class="text-label">Pelanggan</p>
						<p class="text-content">{{ workorder_detail.customer_name }}</p>
					</div>
					<div class="col-md-4">
						<p class="text-label">Asuransi</p>
						<p class="text-content">{{workorder_detail.insurance_company_name}}</p>
					</div>
				</div>
			</div>
		</div>

		<div class="row row-space">
			<div class="col-6 col-md-4">
				<div class="input-group">
					<label class="label">Pending Parts</label>
					<Multiselect 
						:disabled="workorder_detail == null"
						:options="['Yes' , 'No']"
						v-model="form.pending_parts"
						:allowEmpty="false"
					/>
				</div>
			</div>

		</div>
		<div class="row row-space" v-if="backdate">
			<div class="col-12 col-md-12">
				<div class="input-group">
					<label class="label">Tanggal Keluar Mobil</label>
					<Datepicker input-class="input--style-4" class="w-100" type="text" name="policy_expiry" v-model="date" placeholder="Tanggal Keluar Mobil"/>
				</div>
			</div>
		</div>

		<div class="row row-space">
			<div class="col-12">
				<div class="input-group">
					<label class="label">Keterangan</label>
					<textarea
						class="input--style-4 w-100"
						style="line-height: 1.2rem; padding: 10px"
						rows="5"
						v-model="form.detail"
						placeholder="Ketik Keterangan"
						:disabled="workorder_detail == null"
					></textarea>
				</div>
			</div>
			<div class="col-12">
				<div class="input-group">
					<label class="label">Administrasi</label>
					<textarea
						class="input--style-4 w-100"
						style="line-height: 1.2rem; padding: 10px"
						rows="5"
						v-model="form.administration"
						placeholder="Ketik Administrasi"
						:disabled="workorder_detail == null"
					></textarea>
				</div>
			</div>
		</div>

		<div class="row" style="margin: 20px 0">
			<div class="col" style="text-align:center">
				<button type="button" class="btn btn-lg btn-outline-danger" style="width: 75px;" @click="reset">Reset</button>
				<button type="button" class="btn btn-lg btn-primary ml-5" style="width: 75px;" @click="submit">Print</button>
			</div>
		</div>

	</div>
	</template>

<script>
	import Multiselect from 'vue-multiselect'
	import Datepicker from 'vuejs-datepicker'
	import moment from 'moment'

	export default {
		data () {
			return {
				mobile : this.isMobile(),
				options : {
					workorder : [],
				},
				form : {
					detail : '',
					administration : '',
					pending_parts : 'No'
				},
				date : null,
				workorder_id : "",
				workorder_detail : null,
				backdate : true
			}
		},
		components : {
			Multiselect,
			Datepicker
		},
		props : ['selectedWo'],
		mounted () {
			this.$http.get(`/api/v1/exitPermit/${this.selectedWo}`)
			.then((resp)=>{
				this.workorder_detail = resp.data.data;
			})
			.catch((err)=>{
				console.log(err);
			})

			// this.backdate = parseInt(this.selectedWo.slice(1, 3)) < 7 ? true : false
		},
		methods : {
			getWorkOrderOptions(){
				this.$http.get('/api/v1/masterData/workorder?pagination=false')
				.then((resp)=>{
					var data = resp.data.data;
					this.options.workorder = data.map(a => ({form_id : a.form_code, form_code : a.form_code}))
				})
				.then(()=>{
					if (this.selectedWo) this.workorder_id = this.selectedWo
				})
				.catch((err)=>{
					console.log(err);
				})
			},
			reset(){
				this.$swal.fire({
				title: 'Hapus Semua?',
				type: 'warning',
				showCancelButton: true,
				confirmButtonColor: '#3085d6',
				cancelButtonColor: '#d33',
				confirmButtonText: 'Hapus',
				cancelButtonText: 'Kembali'
				}).then((result)=>{
					if(result.value){
						this.workorder_id = '';
						this.workorder_detail = null;
						this.form.detail = '';
						this.form.administration = '';
					}
				})
			},
			validateForm(){
				var valid = true;
				var error = [];

				// if(this.form.detail == '' || this.form.detail == null){//Details [Required]
				//   valid = false;
				//   error.push('Keterangan wajib terisi');
				// }

				// if(this.form.administration == '' || this.form.administration == null){//Administration [Required]
				//   valid = false;
				//   error.push('Administrasi wajib terisi');
				// }

				if(!valid) this.$store.dispatch('triggerAlert', [false, error]);
				else return valid;
			},
			submit(){
				// if(this.workorder_id == '' || this.workorder_id == null) {
				//   this.$store.dispatch('triggerAlert', [false, ['Pilih Work Order']])
				//   return;
				// };

				if(this.validateForm()){
					let form = JSON.parse(JSON.stringify(this.form))
					if(form.pending_parts == 'Yes') form.pending_parts = true
					else form.pending_parts = false

					if(this.backdate) form.created_at = new moment(this.date).format('Y-MM-DD') + " 00:00:00"

					this.$http.post(`/api/v1/exitPermit/${this.selectedWo}`, form)
					.then((resp)=>{
						var detail = this.workorder_detail;
						detail.detail = this.form.detail;
						detail.administration = this.form.administration;
						detail.workorder_id = this.workorder_id;

						this.$emit('goPrint', detail);
					})
					.catch((err)=>{
						console.log(err);
					})
				}
			},
		}
	}
</script>

<style scoped>

	/* ==========================================================================
	#FORM made by Colorlib (https://colorlib.com)
	========================================================================== */
	input {
		outline: none;
		margin: 0;
		border: none;
		-webkit-box-shadow: none;
		-moz-box-shadow: none;
		box-shadow: none;
		width: 100%;
		font-size: 14px;
		font-family: inherit;
	}
	
	.input--style-4 {
		line-height: 50px;
		background: #fafafa;
		-webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
		-moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
		box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
		-webkit-border-radius: 5px;
		-moz-border-radius: 5px;
		border-radius: 5px;
		padding: 0 20px;
		font-size: 16px;
		color: #666;
		-webkit-transition: all 0.4s ease;
		-o-transition: all 0.4s ease;
		-moz-transition: all 0.4s ease;
		transition: all 0.4s ease;
	}
	
	.input--style-4::-webkit-input-placeholder {
		/* WebKit, Blink, Edge */
		color: #666;
	}
	
	.input--style-4:-moz-placeholder {
		/* Mozilla Firefox 4 to 18 */
		color: #666;
		opacity: 1;
	}
	
	.input--style-4::-moz-placeholder {
		/* Mozilla Firefox 19+ */
		color: #666;
		opacity: 1;
	}
	
	.input--style-4:-ms-input-placeholder {
		/* Internet Explorer 10-11 */
		color: #666;
	}
	
	.input--style-4:-ms-input-placeholder {
		/* Microsoft Edge */
		color: #666;
	}
	
	.label {
		font-size: 16px;
		color: #555;
		text-transform: capitalize;
		display: block;
		margin-bottom: 5px;
	}
	
	.radio-container {
		display: inline-block;
		position: relative;
		padding-left: 30px;
		cursor: pointer;
		font-size: 16px;
		color: #666;
		-webkit-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
	}
	
	.radio-container input {
		position: absolute;
		opacity: 0;
		cursor: pointer;
	}
	
	.radio-container input:checked ~ .checkmark {
		background-color: #e5e5e5;
	}
	
	.radio-container input:checked ~ .checkmark:after {
		display: block;
	}
	
	.radio-container .checkmark:after {
		top: 50%;
		left: 50%;
		-webkit-transform: translate(-50%, -50%);
		-moz-transform: translate(-50%, -50%);
		-ms-transform: translate(-50%, -50%);
		-o-transform: translate(-50%, -50%);
		transform: translate(-50%, -50%);
		width: 12px;
		height: 12px;
		-webkit-border-radius: 50%;
		-moz-border-radius: 50%;
		border-radius: 50%;
		background: #57b846;
	}
	
	.checkmark {
		position: absolute;
		top: 50%;
		-webkit-transform: translateY(-50%);
		-moz-transform: translateY(-50%);
		-ms-transform: translateY(-50%);
		-o-transform: translateY(-50%);
		transform: translateY(-50%);
		left: 0;
		height: 20px;
		width: 20px;
		background-color: #e5e5e5;
		-webkit-border-radius: 50%;
		-moz-border-radius: 50%;
		border-radius: 50%;
		-webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
		-moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
		box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
	}
	
	.checkmark:after {
		content: "";
		position: absolute;
		display: none;
	}
	
	.input-group {
		position: relative;
		/* margin-bottom: 22px; */
		padding:20px;
	}
	
	.input-group-icon {
		position: relative;
	}
	
	.input-icon {
		position: absolute;
		font-size: 18px;
		color: #999;
		right: 18px;
		top: 50%;
		-webkit-transform: translateY(-50%);
		-moz-transform: translateY(-50%);
		-ms-transform: translateY(-50%);
		-o-transform: translateY(-50%);
		transform: translateY(-50%);
		cursor: pointer;
	}
	
	/* ==========================================================================
		#TITLE made by Colorlib (https://colorlib.com)
		========================================================================== */
	.title {
		font-size: 40px;
		color: #525252;
		margin-bottom: 40px;
		text-align: center;
	}

	.text-label{
		font-size: 16px;
		font-weight: bold;
		color: #525252;
		margin-bottom: 10px;
		margin-left:10px;
		text-decoration: underline;
	}
	.text-content{
		font-size: 28px;
		font-weight: 500;
		color: black;
	}
</style>